export default "__VITE_ASSET__d9239a99__"